export enum PaymentMethod {
  PayWithSubscription,
  PayNow,
}

export enum PhoneNumberOption {
  NewPhoneNumber,
  KeepExisting,
}
